import request from '@/utils/request'

export function validateMember(query) {
  return request({
    url: '/order/repurchase/validate',
    method: 'get',
    params: query
  })
}

export function fetchGoods(query) {
  return request({
    url: '/order/repurchase/goods',
    method: 'get',
    params: query
  })
}

export function createOrder(data) {
  return request({
    url: '/order/repurchase/create',
    method: 'post',
    data
  })
}
